import { BaseEntityDetails } from "./entity-details.class";
import { Entity } from "./entity.class";
import { Sponsor } from "./sponsor.class";

export class DealDashboardDetails extends BaseEntityDetails {
    investmentManagerMasterId!: number | null;
    investmentManagerName!: string;
    currency!: string;
    portfolioCurrency!: string;
    fundSize!: number;
    strategy!: string;
    vintageYear!: string;
    hasSpotlightInvestment!: boolean;
    portfolioMasterId!: number;
    portfolioName!: string;
    portfolioSeriesMasterId!: number;
    portfolioSeriesName!: string;
    dealMasterId!: number;
    dealName!: string;
    dealAssetClass!: string;
    proxyType!: string;
    isDropdownDeal!: boolean;
    dropdownPortfolioSeries!: Entity[];
    dealDescription!: string;
    investmentType!: string;
    investmentSubType!: string;
    realizationType!: string;
    assetClass!: string;
    purpose!: string;
    sponsors!: Sponsor[];
}
